import expedients from '@/api/apiSferest/services/expedients'

export const getList = ({ commit, state, getters }) => {
  return new Promise((resolve, reject) => {
    let params = {}
    expedients.list(params)
    .then((res) => {
      commit('array/SET_LIST', res.data)
      resolve(res.data)
    })
  })
}
